export * from '../src/views/w3m-approve-transaction-view/index.js';
export * from '../src/views/w3m-upgrade-wallet-view/index.js';
export * from '../src/views/w3m-register-account-name-view/index.js';
export * from '../src/views/w3m-register-account-name-success-view/index.js';
//# sourceMappingURL=embedded-wallet.js.map